export default {
    namespaced: true,

    state: {
        isModalOpen: false,
        windowScrollBarWidth: 0,
        isMatchHelpModalVisible: false
    },

    mutations: {
        openModal(state) {
            state.isModalOpen = true;
        },
        closeModal(state) {
            state.isModalOpen = false;
        },
        setWindowScrollBarWidth(state, width) {
            state.windowScrollBarWidth = width;
        },
        setVisibilityMatchHelpModal(state, value) {
            state.isMatchHelpModalVisible = value;
        }
    },

    getters: {
        isModalOpen: state => {
            return state.isModalOpen;
        },
        windowScrollBarWidth: state => {
            return state.windowScrollBarWidth;
        },
        isMatchHelpModalVisible: state => {
            return state.isMatchHelpModalVisible;
        }

    }
};